document.addEventListener("DOMContentLoaded", function() {
  if (window.location.pathname.includes('/account/register')) {

    function getQueryParam(param) {
      var params = new URLSearchParams(window.location.search);
      return params.get(param);
    }


    function prefillCompanyField() {
      var companyName = getQueryParam('company');

      var companyField = document.querySelector('[name="customer[firma]"]');
      if (companyField) {
        if (companyName) {
          companyField.value = companyName;
          companyField.readOnly = true;
          return true;
        }
      }
      return false;
    }


    var observer = new MutationObserver(function(mutations) {
      if (prefillCompanyField()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });


    if (prefillCompanyField()) {
      observer.disconnect();
    }
  }
});
